import React from 'react';
import { observer } from 'mobx-react';

const Dialog = observer(class Dialog extends React.Component {
  constructor() {
    super();
    this.confirmKey = this.confirmKey.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.confirmKey, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.confirmKey, false);
  }

  confirmKey(e) {
    e.preventDefault();

    if(e.keyCode && (e.keyCode === 13 || e.keyCode === 32)) {
      this.closeDialog(e);
    }
  }

  closeDialog(e) {
    e.preventDefault();
    this.props.store.SessionStore.closeDialog();
  }

  render() {
    const { SessionStore } = this.props.store;

    return(
      <div className="dialog">
        <div className="dialog__content">
          <strong className="dialog__msg" tabIndex="0">{SessionStore.dialogContent.heading}</strong>

          <p>{SessionStore.dialogContent.body}</p>

          {SessionStore.dialogContent.link_text && SessionStore.dialogContent.link_url &&
            <p>
              <a
                href={SessionStore.dialogContent.link_url}
                target="_blank"
              >
                {SessionStore.dialogContent.link_text}
              </a>
            </p>
          }

          <a href="#app" className="btn" onClick={(e) => this.closeDialog(e)}>{SessionStore.dialogContent.button}</a>
        </div>
      </div>
    );
  }
})

export default Dialog;


// WEBPACK FOOTER //
// ./src/app/components/Common/Dialog.js